module.exports = __webpack_public_path__ + "static/img/2.4bd3637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/2.png
// module id = UCSJ
// module chunks = 0